module.exports = __webpack_public_path__ + "0fdff6c2b5d749e2fd6d70c9f7f0afcf.svg";